import styled from 'styled-components';
import { ReactComponent as Calendar } from '../../assets/icons/calendar.svg';
import { ReactComponent as Whatsapp } from '../../assets/icons/whatsapp.svg';
import { ReactComponent as PhoneCall } from '../../assets/icons/phone-call.svg';
import { ReactComponent as ChatBubbleLine } from '../../assets/icons/chat-bubble-line.svg';
import { ReactComponent as MailUnreadOutline } from '../../assets/icons/mail-unread-outline.svg';
import { ReactComponent as Group } from '../../assets/icons/phone-incoming.svg';
import { FaQuestion } from 'react-icons/fa';

interface Props {
  signed: boolean;
}

export const Title = styled.h2`
  font-size: 40px;
  text-align: center;
  font-weight: 700;
  color: ${(props) =>
    props.theme.colors.footerFontColor ?? props.theme.colors.primaryDark1};
  margin: 0px 0 40px 0;

  @media screen and (max-width: 960px) {
    font-size: 28px;
    padding: 20px;
    margin-bottom: 0;
  }
`;

export const Information = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (min-width: 961px) and (max-width: 1200px) {
    flex-wrap: wrap;
  }

  @media screen and (max-width: 960px) {
    flex-direction: column;
    justify-content: initial;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 1200px;
  margin: 0 auto;
  background: ${(props) => props.theme.colors.footerColor};
  padding: 40px 0;
  height: 100%;
  /* align-items:center; */

  @media screen and (min-width: 961px) and (max-width: 1200px) {
    width: auto;
  }

  @media screen and (max-width: 960px) {
    width: 100%;
    padding: 0px;
    /* display:initial; */
  }
`;

export const CircularCard = styled.div`
  width: 170px;
  height: 170px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(79, 105, 132, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusBotoesContato)
      ? `${props.theme.radiusBotoesContato}px`
      : '10px'};
  padding: 38px 21px;
  margin: 0 18px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }

  @media screen and (min-width: 961px) and (max-width: 1200px) {
    margin-bottom: 14px;
  }

  @media screen and (max-width: 960px) {
    margin: 8px 0;
    width: 100%;
    height: 72px;
    display: flex;
    padding: 20px;
    border-radius: ${(props) =>
      Number(props.theme.radiusBotoesContato)
        ? `${props.theme.radiusBotoesContato}px`
        : '10px'};
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const Text = styled.h2`
  color: ${(props) => props.theme.colors.secundary};
  width: 128px;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  margin-top: 12px;

  #bold {
    font-weight: 700;
  }

  #break {
    @media screen and (max-width: 960px) {
      display: none;
    }
  }

  @media screen and (max-width: 960px) {
    margin-left: 12px;
    width: auto;
    margin-top: 0;
    padding: 7px 0 6px 0;

    br {
      display: none;
    }
  }
`;

export const Icon = styled.div`
  text-align: center;
`;

export const Img = styled.img`
  @media screen and (max-width: 960px) {
    width: 30px;
    height: 30px;
    margin-right: 16px;
  }
`;

export const Wrapper = styled.div<Props>`
  background-color: ${(props) => props.theme.colors.footerColor};
  display: flex;
  flex-direction: column;
  grid-area: footer;
  /* min-height: ${(props) =>
    props.signed ? 'calc(100% - 258px)' : 'calc(100% - 441px)'}; */
  /* min-height: calc(100% - 441px); */

  @media screen and (max-width: 960px) {
    height: auto;
    padding: 32px 20px;
  }
`;

export const IconCalendar = styled(Calendar)`
  width: 44px;
  height: 44px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconWhatsapp = styled(Whatsapp)`
  width: 44px;
  height: 44px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconPhoneCall = styled(PhoneCall)`
  width: 44px;
  height: 44px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconChatBubbleLine = styled(ChatBubbleLine)`
  width: 44px;
  height: 44px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconMailUnreadOutline = styled(MailUnreadOutline)`
  width: 44px;
  height: 44px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconGroup = styled(Group)`
  width: 44px;
  height: 44px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconFaQuestion = styled(FaQuestion)`
  width: 44px;
  height: 44px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;
